// extracted by mini-css-extract-plugin
export var buttonContainer = "_7l-1";
export var fontSizeSelect = "_7l-3";
export var formatSelect = "_7l-2";
export var formats = "_7l-4";
export var hidden = "_7l-5";
export var icon = "_7l-6";
export var select = "_7l-0";